export default "__VITE_ASSET__Grnbgwax__"